/**
 * Where the visitor's cookie answer lives, and the shape's version.
 *
 * Kept apart from `cookie-consent.ts` because the root layout's consent bootstrap — a script the
 * server writes into the page before anything else runs — has to read the very same key and
 * version, and `cookie-consent.ts` imports React hooks that a Server Component must not import.
 */

export const COOKIE_CONSENT_STORAGE_KEY = "tb-consentimento-cookies";

/**
 * Written into the record so another shape can be told apart from this one. A record of another
 * version is **not** migrated and not repaired: consent is a fact about a specific question, and
 * the answer to a question that changed is not an answer to the new one. It goes back to pending.
 */
export const COOKIE_CONSENT_SCHEMA_VERSION = 1;
